export { default } from './Blogs.component';
